import React from 'react'
import { Link } from 'react-router-dom'
import { theme } from '../../../theme/theme'
import { Icon, IconChoices } from '../../common/Icon'

export interface GettingStartedSideBarCallout {
  text: string
  path: string
}

export const GettingStartedSideBarCallout = ({
  text,
  path,
}: GettingStartedSideBarCallout): JSX.Element => {
  return (
    <Link to={path}>
      <div
        className={`flex items-center rounded-md 
          ${'bg-brandLightBrown hover:bg-brandBrown/50'}
          py-2 pl-3 pr-1.5
         `}
      >
        <Icon icon={IconChoices.CHECK_CIRCLE} color={theme.colors.brandGreen} />
        <p style={theme.textVariants.captionBold} className="w-full px-2">
          {text}
        </p>
        <Icon icon={IconChoices.ARROW} />
      </div>
    </Link>
  )
}
